/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useState, useRef } from 'react'
import { Modal, Spin } from 'antd'
// import { modalZIndex } from '../../task/util'
import { FormGeneral } from './unitModalForms'
import { getUnitNameMap, postUnitInfo } from 'api/pgads'
// const DATE_FORMAT_API = 'YYYY-MM-DD'

// const DEFAULT_ACTIVE_TAB = 'general'
import emptyId from './index'
const UnitModal = ({
  isNew,
  hide,
  unit = {},
  unitList = [],
  //   effectiveDate,
  //   updateTask,
  // createTask,
  // setError,
  unitTypes,
  utilityNameMap,
  fuelCodes,
  fuelCodeDataList,
  timeZones,
  stationType,
  ruleSetTypes,
  loadCharTypes,
  retrieve,
  validateData,
  apiTargetInfo,
  spinning,
  CLIENT,
  setSpinning = _ => _,
  ...props
}) => {
  //   const [getUnitTypes, loading] = usePmgrApi(api.getUnitTypes)

  // const [getDesignSeries, loading1] = usePmgrApi(api.getDesignSeries)
  // const [getFuelCodes, loading2] = usePmgrApi(api.getFuelCodes)
  // const [getStates, loading3] = usePmgrApi(api.getStates)
  // const [getControlAreas, loading5] = usePmgrApi(api.getControlAreas)
  // const [getSeries, loading6] = usePmgrApi(api.getSeries)

  //   const [unitTypes, setUnitTypes] = useState([])
  // const [designSeries, setDesignSeries] = useState([])
  // const [fuelCodes, setFuelCodes] = useState([])
  // const [unitState, setUnitState] = useState([])
  // const [controlAreas, setControlAreas] = useState([])
  // const [series, setSeries] = useState([])

  const [baseData, setBaseData] = useState({
    ...unit,
    retired: unit.retired === '1',
  })
  const unitFormGeneralRef = useRef()
  // const unitFormISOInfoRef = useRef()

  const onOk = () => {
    unitFormGeneralRef.current &&
      unitFormGeneralRef.current.validateFields(error => {
        if (error) {
          //   setActiveTab(DEFAULT_ACTIVE_TAB)
        } else {
          const mutatedData = {
            ...baseData,
            retired: baseData.retired === 'Y' ? '1' : '0',
            id2: baseData.id2 === 'Y' ? 'Y' : 'N',
            rsRequired: baseData.rsRequired === 'Y' ? 'Y' : 'N',
            dailyDetail: baseData.dailyDetail === 'Y' ? 'Y' : 'N',
            daylightSavings: baseData.daylightSavings === 'Y' ? 'Y' : 'N',
            rStationCode:
              baseData.rStationCode === 'Y' ? 'Y' : baseData.rStationCode,
            // retiredDate:
            //   baseData.retiredDate &&
            //   (baseData.retiredDate.length > 0 ||
            //     baseData.retiredDate !== 'Invalid date')
            //     ? moment(baseData.retiredDate, 'MM/DD/YYYY')
            //     : undefined,
          }
          if (isNew) {
            const isValid = validateData(mutatedData)
            if (isValid) {
              const newMutated = [mutatedData].map(d => ({
                ...d,
                primaryFuel:
                  d.primaryFuel === emptyId || d.primaryFuel === '[NA]'
                    ? undefined
                    : d.primaryFuel,
                secondaryFuel:
                  d.secondaryFuel === emptyId || d.secondaryFuel === '[NA]'
                    ? undefined
                    : d.secondaryFuel,
                tertiaryFuel:
                  d.tertiaryFuel === emptyId || d.tertiaryFuel === '[NA]'
                    ? undefined
                    : d.tertiaryFuel,
                quarternaryFuel:
                  d.quarternaryFuel === emptyId || d.quarternaryFuel === '[NA]'
                    ? undefined
                    : d.quarternaryFuel,
              }))
              setSpinning(true)
              postUnitInfo(apiTargetInfo)(newMutated, true)
                // createTask(apiTargetInfo)([mutatedData], true)
                .fork(props.setError, _ => {
                  setSpinning(false)
                  retrieve()
                  hide()
                  props.loadDataForDate(props.date)
                  getUnitNameMap(apiTargetInfo).fork(props.setError, data =>
                    props.saveUnitNameMap(data)
                  )
                })
            }
          }
        }
      })
  }

  return (
    <Modal
      title={isNew ? 'Create New Unit' : `Update ( ${unit.unitName} )`}
      width="90vw"
      visible
      onOk={onOk}
      okText="Save"
      onCancel={hide}
      centered
      bodyStyle={{ minHeight: '50vh' }}
      maskClosable={false}
      zIndex={100}
    >
      <Spin spinning={spinning}>
        <FormGeneral
          CLIENT={CLIENT}
          unitFormGeneralRef={unitFormGeneralRef}
          isNew={isNew}
          unit={baseData}
          setUnit={setBaseData}
          unitList={unitList}
          unitTypes={unitTypes}
          // designSeries={designSeries}
          fuelCodes={fuelCodes}
          // unitState={unitState}
          // controlAreas={controlAreas}
          // series={series}
          utilityNameMap={utilityNameMap}
          timeZones={timeZones}
          stationType={stationType}
          ruleSetTypes={ruleSetTypes}
          loadCharTypes={loadCharTypes}
          fuelCodeDataList={fuelCodeDataList}
        />
      </Spin>
    </Modal>
  )
}

export default UnitModal
